module.exports = __webpack_public_path__ + "img/x.76477219.svg";